import type { FC, ReactNode } from 'react'

import { Container } from '@/components/generals/container'
import { PillLink } from '@/components/generals/pill-link'
import { SectionLabel } from '@/components/generals/section-label'

import { company } from '@/constants/site'

const Cta: FC = (): ReactNode => {
    return (
        <section
            id='simulacao'
            data-header-theme='dark'
            className='relative isolate overflow-hidden bg-ink py-28 text-white md:py-40'
        >
            <div
                aria-hidden='true'
                className='bg-grid-dark absolute inset-0 -z-10 [mask-image:radial-gradient(65%_60%_at_50%_55%,black,transparent)]'
            />

            <div
                aria-hidden='true'
                className='cta-glow absolute -inset-x-1/4 bottom-0 -z-10 h-2/3 bg-[radial-gradient(40%_70%_at_50%_100%,rgba(20,130,220,0.55),transparent_75%)]'
            />

            <Container className='flex flex-col items-center text-center'>
                <SectionLabel tone='dark'>Fale com a Ativa</SectionLabel>

                <h2 className='reveal mt-6 max-w-4xl font-heading text-[2.1rem] uppercase leading-[1.02] tracking-[-0.02em] md:text-6xl lg:text-[4.25rem]'>
                    Potencialize suas Operações de Comércio Exterior.
                </h2>

                <p className='mt-8 max-w-xl text-lg leading-relaxed text-white/70'>
                    Conheça nossos serviços sem compromisso. Estamos prontos para atendê-lo e superar suas expectativas. Agende uma conversa com nossos especialistas.
                </p>

                <div className='mt-10 flex flex-wrap justify-center gap-3'>
                    <PillLink href={company.simulationUrl} variant='highlight' size='lg'>
                        Faça uma simulação
                    </PillLink>

                    <PillLink href='/contato' variant='outline-light' size='lg'>
                        Agende uma conversa
                    </PillLink>
                </div>
            </Container>
        </section>
    )
}

export default Cta
